/* The Sauna Place: About Us + Meet the Team behavior.
   1) Timeline rail: arrow buttons and progress bar.
   2) Video loops: load the poster and play only while near the screen.
      Reduced motion keeps the still poster. */
(function () {
  if (window.__tspaInit) return;
  window.__tspaInit = true;

  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function initRail(root) {
    var rail = root.querySelector('.tl-rail');
    if (!rail || rail.__tspa) return;
    rail.__tspa = true;
    var bar = root.querySelector('.tl-progress span');
    var prev = root.querySelector('.tl-btn[data-dir="-1"]');
    var next = root.querySelector('.tl-btn[data-dir="1"]');
    function gap() {
      var g = parseFloat(window.getComputedStyle(rail).columnGap);
      return isNaN(g) ? 28 : g;
    }
    function step() {
      var li = rail.querySelector('li');
      return li ? li.getBoundingClientRect().width + gap() : 300;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? rail.scrollLeft / max : 1;
      if (bar) bar.style.width = Math.max(8, Math.round(pct * 100)) + '%';
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    }
    [prev, next].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        rail.scrollBy({ left: step() * Number(b.getAttribute('data-dir')), behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  var io = null;
  function setPoster(v) {
    var p = v.getAttribute('data-poster');
    if (p && !v.getAttribute('poster')) v.setAttribute('poster', p);
  }
  function play(v) {
    if (reduce) return;
    if (v.preload === 'none') v.preload = 'auto';
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
  }
  function initVideos(root) {
    var vids = root.querySelectorAll('video.tspa-v');
    for (var i = 0; i < vids.length; i++) {
      var v = vids[i];
      if (v.__tspa) continue;
      v.__tspa = true;
      v.muted = true;
      if (!('IntersectionObserver' in window)) { setPoster(v); play(v); continue; }
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var t = en.target;
            if (en.isIntersecting) { setPoster(t); play(t); }
            else if (!t.paused) { t.pause(); }
          });
        }, { rootMargin: '200px 0px', threshold: 0 });
      }
      io.observe(v);
    }
  }

  function init(root) {
    root = root || document;
    var rails = root.querySelectorAll('.tspa-timeline');
    for (var i = 0; i < rails.length; i++) initRail(rails[i]);
    if (root.classList && root.classList.contains('tspa-timeline')) initRail(root);
    initVideos(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
